import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LiveTileState } from '../../services/live-stream-manager.service';
import { MessagingServiceService } from 'src/app/Services/messaging-service.service';
import { isRustAgentUser } from 'src/app/agent-deploy/agent-deploy.config';
import { sysConfig } from 'src/app/sysConfig';

@Component({
  selector: 'app-live-tile',
  templateUrl: './live-tile.component.html',
  styleUrls: ['./live-tile.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LiveTileComponent {
  @Input() tile: LiveTileState | null = null;
  @Input() dense: boolean = false;
  /** Vertical feed card on mobile grid/wall — larger preview, tap to expand. */
  @Input() mobileFeed = false;
  @Input() duplicateCount: number = 1;
  @Input() emptyHint = '';

  @Output() select = new EventEmitter<string>();
  @Output() close = new EventEmitter<string>();
  @Output() snapshot = new EventEmitter<string>();
  @Output() retry = new EventEmitter<string>();

  readonly sysConfig = sysConfig;

  constructor(private messagingService: MessagingServiceService) {}

  onSelect() {
    if (this.tile?.tileId) this.select.emit(this.tile.tileId);
  }

  onClose(e: MouseEvent) {
    e.stopPropagation();
    if (this.tile?.tileId) this.close.emit(this.tile.tileId);
  }

  onSnapshot(e: MouseEvent) {
    e.stopPropagation();
    if (this.tile?.tileId) this.snapshot.emit(this.tile.tileId);
  }

  onRetry(e: MouseEvent) {
    e.stopPropagation();
    if (this.tile?.tileId) this.retry.emit(this.tile.tileId);
  }

  get title(): string {
    const emp = this.tile?.employee;
    return emp?.name || emp?.display_name || (this.tile?.employeeId ? `User ${this.tile.employeeId}` : 'No stream');
  }

  get showRustAgentBetaBadge(): boolean {
    if (!sysConfig.rustAgentBetaBadgeEnabled || this.isEmpty) {
      return false;
    }
    const emp = this.tile?.employee;
    if (isRustAgentUser(emp)) {
      return true;
    }
    const id = this.tile?.employeeId ?? emp?.id;
    if (id == null || id === '') {
      return false;
    }
    const fbUser = this.messagingService
      .getLatestFirebaseUsersSnapshot()
      .find((u) => String(u?.id) === String(id));
    return isRustAgentUser(fbUser);
  }

  get status(): string {
    return this.tile?.status || 'empty';
  }

  get isEmpty(): boolean {
    return this.status === 'empty' || !this.tile?.employeeId;
  }

  get canClose(): boolean {
    return !this.isEmpty && this.status !== 'ended';
  }

  get canSnapshot(): boolean {
    return !this.isEmpty && this.status !== 'empty' && this.status !== 'ended';
  }

  get canRetry(): boolean {
    return this.status === 'failed' || this.status === 'offline' || this.status === 'stale';
  }

  get emptyTitle(): string {
    return this.dense ? 'Add stream' : 'No stream yet';
  }

  get emptySubtitle(): string {
    if (this.emptyHint) return this.emptyHint;
    return 'Add an employee from the employee list.';
  }
}

